/** Stroke icons on a 16px grid; they inherit currentColor. */

const PATHS = {
  home: "M2.5 7 8 2.5 13.5 7v6a.5.5 0 0 1-.5.5H10V10H6v3.5H3a.5.5 0 0 1-.5-.5Z",
  symbols: "M5.5 2.5h5v5h-5ZM2.5 13.5a3 3 0 1 1 6 0ZM10 13.5l1.75-3.5 1.75 3.5Z",
  builder: "M2.5 13.5 9 7M10.5 2.5l3 3-2 2-3-3ZM4 4.5h2M5 3.5v2M11.5 10.5h2M12.5 9.5v2",
  gallery: "M2.5 2.5h4.5v4.5H2.5ZM9 2.5h4.5v4.5H9ZM2.5 9h4.5v4.5H2.5ZM9 9h4.5v4.5H9Z",
  themes: "M8 2.5a5.5 5.5 0 1 0 0 11c.8 0 1.2-.6 1-1.3-.3-.9.3-1.7 1.2-1.7H12a1.5 1.5 0 0 0 1.5-1.5A5.5 5.5 0 0 0 8 2.5ZM5 7.5h.01M7 5h.01M10 5.5h.01",
  skids: "M2.5 4h3v3h-3ZM10.5 9h3v3h-3ZM5.5 5.5H8v5h2.5",
  faceplates: "M2.5 2.5h11v11h-11ZM2.5 6h11M5 9h3M5 11h5",
  spatial: "M8 1.8 13.5 5v6L8 14.2 2.5 11V5ZM2.5 5 8 8.2 13.5 5M8 8.2v6",
  docs: "M3 2.5h7.5l2.5 2.5v8.5H3ZM10.5 2.5V5H13M5.5 8h5M5.5 10.5h5",
  roadmap: "M2.5 3.5h4l1 1.5h6v8H2.5ZM2.5 3.5v10",
  search: "M7 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM10.5 10.5 13.5 13.5",
  sun: "M8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM8 1.5v1.5M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1 1M11.6 11.6l1 1M3.4 12.6l1-1M11.6 4.4l1-1",
  moon: "M13 9.5A5.5 5.5 0 0 1 6.5 3a5.5 5.5 0 1 0 6.5 6.5Z",
  sidebar: "M2.5 3h11v10h-11ZM6 3v10",
  chevron: "M6 4l4 4-4 4",
  external: "M9.5 2.5h4v4M13.5 2.5 8 8M11.5 9.5v4h-9v-9h4",
  download: "M8 2.5v8M4.5 7.5 8 11l3.5-3.5M3 13.5h10",
  link: "M6.5 9.5a3 3 0 0 0 4.2 0l2.1-2.1a3 3 0 0 0-4.2-4.2l-.7.7M9.5 6.5a3 3 0 0 0-4.2 0L3.2 8.6a3 3 0 0 0 4.2 4.2l.7-.7",
  arrow: "M3 8h10M9 4l4 4-4 4",
  menu: "M2.5 4h11M2.5 8h11M2.5 12h11",
  github:
    "M8 1.5a6.5 6.5 0 0 0-2.05 12.67c.33.06.45-.14.45-.31v-1.1c-1.8.39-2.18-.87-2.18-.87-.3-.75-.72-.95-.72-.95-.59-.4.04-.4.04-.4.65.05 1 .67 1 .67.58 1 1.52.71 1.89.54.06-.42.23-.71.41-.87-1.44-.16-2.96-.72-2.96-3.2 0-.71.25-1.29.67-1.74-.07-.17-.29-.83.06-1.72 0 0 .55-.18 1.79.66a6.2 6.2 0 0 1 3.26 0c1.24-.84 1.79-.66 1.79-.66.35.89.13 1.55.06 1.72.42.45.67 1.03.67 1.74 0 2.49-1.52 3.04-2.97 3.2.24.2.44.6.44 1.2v1.78c0 .17.12.37.45.31A6.5 6.5 0 0 0 8 1.5Z",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 16, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      width={size}
      height={size}
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

export const Mark = () => (
  <svg className="mark" viewBox="0 0 32 32" aria-hidden="true">
    <rect width="32" height="32" rx="8" />
    <circle cx="14" cy="17.5" r="7.5" fill="none" strokeWidth="2.4" />
    <path d="M17 10V5.5h6V12" fill="none" strokeWidth="2.4" strokeLinejoin="round" />
    <circle className="dot" cx="14" cy="17.5" r="2.6" />
  </svg>
);
